import { PaginationContainer } from "./styled";
import React from "react";
import { Pagination } from "@mui/material";

const BarekamPagination = ({ totalItems, pageSize, currentPage, onPageChange }: BarekamPaginationProps) => {
    if (totalItems > pageSize) {
        return (
            <PaginationContainer>
                <Pagination count={Math.ceil(totalItems / pageSize)}
                    page={currentPage + 1}
                    onChange={onPageChange}
                />
            </PaginationContainer>
        );
    } else {
        return <></>
    }
}

interface BarekamPaginationProps {
    totalItems: number,
    pageSize: number,
    currentPage: number,

    onPageChange: (event: any, newPage: number) => void
}

export default BarekamPagination;
